<template>
  <label>
    <inline-field-actions :schema="schema"></inline-field-actions>
    <div class="input input--checkbox">
      <input
        type="checkbox"
        class="input__default"
        v-model="value"
        :autocomplete="schema.autocomplete"
        :disabled="disabled"
        :name="schema.inputName"
        @change="handleChange">
      <div class="input__styled input__styled--checkbox"></div>
    </div>
  </label>
</template>

<script>
  import { abstractField } from 'vue-form-generator';
  import { mapMutations } from 'vuex';

  export default {
    mixins: [abstractField],

    watch: {
      value() {
        if (this.schema.onChange) this.schema.onChange.call(this, this.value);
      },
    },

    methods: {
      ...mapMutations('admin', [
        'setFormChanged',
      ]),

      formatValueToModel(value) {
        return value;
      },

      handleChange() {
        this.setFormChanged(true);
      },
    },
  };
</script>
